import { 	 
	CLOSE_ADD_NEW_SONG_MODAL,
	CLOSE_COUNTRY_SONGS_MODAL,
	CLOSE_CREATE_PLAYLIST_MODAL,
	CLOSE_EDIT_SONG_MODAL,
	CLOSE_RANDOM_SONGS_LIST_MODAL,
	CLOSE_REGISTRATION_MODAL,
	CLOSE_SEARCH_SONG_MODAL,
	CLOSE_SONG_INFO_MODAL,
	CLOSE_USER_CREATED_PLAYLISTS,
	CLOSE_USER_PLAYLISTS_MODAL,
	CLOSE_USER_FAVORITE_SONGS,
	CLOSE_ADD_SONG_TO_PLAYLIST_MODAL,
	CLOSE_USER_UPLOADED_SONGS,
	OPEN_COUNTRY_SONGS_MODAL,
	OPEN_EDIT_SONG_MODAL,
	OPEN_RANDOM_SONGS_LIST_MODAL,
	OPEN_SEARCH_SONG_MODAL,
	OPEN_SONG_INFO_MODAL,
	OPEN_USER_FAVORITE_SONGS,
	OPEN_ADD_SONG_TO_PLAYLIST_MODAL,
	OPEN_USER_CREATED_PLAYLISTS,
	OPEN_USER_PLAYLISTS_MODAL,
	OPEN_USER_UPLOADED_SONGS,	
	SELECT_VIEW_OPTION,	
	TOGGLE_ADD_NEW_SONG_MODAL,
	TOGGLE_COUNTRIES_LIST_MODAL,
	TOGGLE_CREATE_PLAYLIST_MODAL,
	TOGGLE_RANDOM_SONGS_LIST_MODAL,
	TOGGLE_USER_PLAYLISTS_MODAL
	
} from '../constants/modal-action-types';

const initialState = {
	showAddNewSongModal:false,
	showAddSongToPlaylistModal: false,
	showCountriesListModal: false,
	showCountrySongsModal: false,
	showCreatePlaylistModal:false,
	showEditSongModal: false,
	showLoginModal: false,
	showRandomSongsModal: false,
	showRegistrationModal: false,
	showSearchSongModal: false,
	showUserCreatedPlaylists: false,
	showUserDashboardModal: false,
	showUserFavoriteSongs: false,
	showUserPlaylistsModal: false,
	showUserUploadedSongs: false,
	viewOptions:['both', 'listOnly', 'mapOnly'],
	viewOptionSelected:'Both'
};

export default function modalReducers(state = initialState, action) {
	if (action.type === CLOSE_ADD_NEW_SONG_MODAL) {
		return Object.assign({}, state, {
			showAddNewSongModal: false
		});
	}
	if (action.type === CLOSE_ADD_SONG_TO_PLAYLIST_MODAL) {
		return Object.assign({}, state, {			
			showAddSongToPlaylistModal: false
		});
	}
	if (action.type === CLOSE_COUNTRY_SONGS_MODAL) {
		return Object.assign({}, state, {
			showCountrySongsModal: false
		});
	}
	if (action.type === CLOSE_CREATE_PLAYLIST_MODAL) {
		return Object.assign({}, state, {
			showCreatePlaylistModal: false
		});
	}
	if (action.type === CLOSE_EDIT_SONG_MODAL) {
		return Object.assign({}, state, {
			showEditSongModal: false,
			showUserDashboardModal: true
		});
	}
	if (action.type === CLOSE_RANDOM_SONGS_LIST_MODAL) {
		return Object.assign({}, state, {
			showRandomSongsModal: false
		});
	}
	if (action.type === CLOSE_REGISTRATION_MODAL) {
		return Object.assign({}, state, {
			showRegistrationModal: false
		});
	}
	if (action.type === CLOSE_SEARCH_SONG_MODAL) {
		return Object.assign({}, state, {
			showSearchSongModal: false
		});
	}

	if (action.type === CLOSE_USER_CREATED_PLAYLISTS) {
		return Object.assign({}, state, {
			showUserCreatedPlaylists: false,
		});
	}
	if (action.type === CLOSE_USER_FAVORITE_SONGS) {
		return Object.assign({}, state, {
			showUserFavoriteSongs: false,
		});
	}
	if (action.type === CLOSE_USER_PLAYLISTS_MODAL){
		return Object.assign({}, state, {
			showUserPlaylistsModal: false,
		});
	}
	if (action.type === CLOSE_USER_UPLOADED_SONGS) {
		return Object.assign({}, state, {			
			showUserUploadedSongs: false
		});
	}
	if (action.type === OPEN_ADD_SONG_TO_PLAYLIST_MODAL) {
		return Object.assign({}, state, {			
			showAddSongToPlaylistModal: true
		});
	}
	if (action.type === OPEN_COUNTRY_SONGS_MODAL) {
		return Object.assign({}, state, {
			showAddNewSongModal:false,
			showCountrySongsModal: true
		});
	}
	if (action.type === OPEN_EDIT_SONG_MODAL) {
		return Object.assign({}, state, {
			showEditSongModal: true			
		});
	}
	if (action.type === OPEN_RANDOM_SONGS_LIST_MODAL) {
		return Object.assign({}, state, {
			showRandomSongsModal: true
		});
	}
	if (action.type === OPEN_SEARCH_SONG_MODAL) {
		return Object.assign({}, state, {
			showSearchSongModal: true
		});
	}	
	if (action.type === OPEN_USER_CREATED_PLAYLISTS) {
		return Object.assign({}, state, {
			showUserCreatedPlaylists: true,
			showEditSongModal: false,
			showUserFavoriteSongs: false,
			showUserUploadedSongs: false
		});
	}
	if (action.type === OPEN_USER_FAVORITE_SONGS) {
		return Object.assign({}, state, {
			showEditSongModal: false,
			showUserCreatedPlaylists: false,
			showUserFavoriteSongs: true,
			showUserUploadedSongs: false
		});
	}
	if (action.type === OPEN_USER_PLAYLISTS_MODAL){
		return Object.assign({}, state, {
			showUserPlaylistsModal: true,
		});
	}
	if (action.type === OPEN_USER_UPLOADED_SONGS) {
		return Object.assign({}, state, {
			showEditSongModal: false,
			showUserCreatedPlaylists: false,
			showUserFavoriteSongs: false,
			showUserUploadedSongs: true
		});
	}
	if (action.type === SELECT_VIEW_OPTION){
		return Object.assign({}, state, {
			viewOptionSelected:action.payload
		})
	}
	if (action.type === TOGGLE_ADD_NEW_SONG_MODAL) {
		return Object.assign({}, state, {
			showAddNewSongModal: !state.showAddNewSongModal,
			showCountrySongsModal: false
		});
	}
	if (action.type === TOGGLE_COUNTRIES_LIST_MODAL) {
		return Object.assign({}, state, {
			showCountriesListModal: !state.showCountriesListModal
		});
	}
	if (action.type === TOGGLE_CREATE_PLAYLIST_MODAL) {
		return Object.assign({}, state, {
			showCreatePlaylistModal: !state.showCreatePlaylistModal,
			showAddNewSongModal: false,
			showCountrySongsModal: false,
			showSearchSongModal: false
		});
	}
	if (action.type === TOGGLE_RANDOM_SONGS_LIST_MODAL){
		return Object.assign({}, state, {
			showRandomSongsModal: !state.showRandomSongsModal
		});
	}
	if (action.type === TOGGLE_USER_PLAYLISTS_MODAL) {
		return Object.assign({}, state, {
			showUserPlaylistsModal: !state.showUserPlaylistsModal
		});
	}
	
	return state;
}
